// import React, { useEffect, useState } from 'react'
// import index from '../Home/index.css';
// // import banner1 from './banner/banner1.png'
// import banner8 from './banner/banner8.png'
// import banner7 from './banner/banner7.png'
// import banner6 from './banner/banner6.png'
// import banner5 from './banner/banner5.png'
// import banner4 from './banner/banner4.png'
// import banner3 from './banner/banner3.png'
// import banner2 from './banner/banner2.png'
// import { Carousel } from 'react-bootstrap';
// import { Card } from 'react-bootstrap';
// import CardGroup from 'react-bootstrap/CardGroup';
// import A320 from './banner/A320.png'
// import B320 from './banner/B320.png'
// import C320 from './banner/C320.png'
// import D320 from './banner/D320.png'
// import F320 from './banner/F320.png'
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
// import lionsimg from './banner/lionsimg.jpg'
// import lionsimg1 from './banner/lionsimg1.jpg'
// import lionsimg2 from './banner/lionsimg2.jpg'
// import lionsimg3 from './banner/lionsimg3.jpg'
// import Header from '../Header/Header';
// import Footer from '../Footer/Footer';
// import TopNavbar from '../Navbar/TopNavbar';
// import { BrowserRouter, Route, Routes } from 'react-router-dom';



// function Home() {

//     const [index, setIndex] = useState(0);

//     const handleSelect = (selectedIndex) => {
//         setIndex(selectedIndex);
//     }

//     useEffect(() => {
//         const intervalId = setInterval(() => {
//             setIndex((prevIndex) => (prevIndex === 7 ? 0 : prevIndex + 1));
//         }, 2000);
//         return () => clearInterval(intervalId);
//     }, []);

//     const cardStyle = {
//         borderRadius: '15px',
//         overflow: 'hidden',
//         transition: 'transform 0.3s ease',
//         boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
//     };

//     const cardImageStyle = {
//         transition: 'transform 0.3s ease',
//     };

//     const handleMouseEnter = (event) => {
//         event.target.style.transform = 'scale(1.05)';
//     };

//     const handleMouseLeave = (event) => {
//         event.target.style.transform = 'scale(1)';
//     };


//     return (
//         <div>

//             <TopNavbar />
//             <div>
//                 <Carousel activeIndex={index} onSelect={handleSelect} interval={null}>
//                     <Carousel.Item>
//                         {/* <img src={banner1} className="d-block w-100" alt="Banner 1" /> */}
//                     </Carousel.Item>
//                     <Carousel.Item style={{ padding: "30px" }}>
//                         <img src={banner2} className="d-block w-100" alt="Banner 2" />
//                     </Carousel.Item>
//                     <Carousel.Item style={{ padding: "30px" }}>
//                         <img src={banner3} className="d-block w-100" alt="Banner 3" />
//                     </Carousel.Item>
//                     <Carousel.Item style={{ padding: "30px" }}>
//                         <img src={banner4} className="d-block w-100" alt="Banner 4" />
//                     </Carousel.Item>
//                     <Carousel.Item style={{ padding: "30px" }}>
//                         <img src={banner5} className="d-block w-100" alt="Banner 5" />
//                     </Carousel.Item>
//                     <Carousel.Item style={{ padding: "30px" }}>
//                         <img src={banner6} className="d-block w-100" alt="Banner 6" />
//                     </Carousel.Item>
//                     <Carousel.Item style={{ padding: "30px" }}>
//                         <img src={banner7} className="d-block w-100" alt="Banner 7" />
//                     </Carousel.Item>
//                     <Carousel.Item style={{ padding: "30px" }}>
//                         <img src={banner8} className="d-block w-100" alt="Banner 8" />
//                     </Carousel.Item>
//                 </Carousel>

//             </div>
//             <br />

//             <div>

//                 <Card className="md-4 " style={{ width: '100%', border: 'none', boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)', transition: 'transform 0.3s ease' }}>
//                     <Card.Body>
//                         <Card.Title style={{ fontSize: '1rem', fontWeight: 'bold' }}>DIVERSITY BRIDGES ALL DIVIDES</Card.Title>
//                         <Card.Text style={{ color: '#666666' }} >Creating Harmony Through Services With international President, Dr. Jung-Yul Choi</Card.Text>
//                     </Card.Body>
//                 </Card>

//                 <Card className=" md-4" style={{ width: '100%', border: 'none', boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)', transition: 'transform 0.3s ease' }}>
//                     <Card.Body>
//                         <Card.Title style={{ fontSize: '1rem', fontWeight: 'bold' }}>Lions Clubs International Multiple District 320</Card.Title>
//                         <Card.Text style={{ color: '#666666' }}>
//                             Hard work: The importance of giving your all with consistency, vision, and passion. Never allowing a crisis to go unserved. These are the values passed on by a loving mother to her son - 103rd International President Dr. Jung-Yul Choi. As a member of the Busan Jae-IL Lions Club in the Republic of Korea for over 40 years, international president Choi leads by example. His career and life have been defined by the work ethic instilled in him as a child, along with a passion to bridge differences, connect people, and embrace diversity to create harmony for all.
//                         </Card.Text>
//                     </Card.Body>
//                 </Card>
//             </div>

//             <div >
//                 <p style={{ fontSize: '2rem', fontWeight: 'bold', color: "black" }}>OUR DISTRICTS</p>
//             </div>

//             <center >
//                 <div style={{ height: '60%', width: '80%', alignItems: 'center', justifyContent: 'center' }}>

//                     <CardGroup style={{ gap: '2rem' }}>
//                         <Row >
//                             <Col xs={12} sm={6} md={4} className="mb-4">
//                                 <Card style={cardStyle} className='A320'>
//                                     <Card.Img
//                                         variant="top"
//                                         src={A320}
//                                         style={cardImageStyle}
//                                         onMouseEnter={handleMouseEnter}
//                                         onMouseLeave={handleMouseLeave}
//                                     />
//                                     <Card.Body >
//                                         <Card.Title>District 320A</Card.Title>
//                                         <Card.Text>Raichur,Bidar,MahabubNagar,<br />RR,<a href='#'><b>READ MORE</b></a></Card.Text>
//                                         {/* <a href='#'>READ MORE</a> */}
//                                     </Card.Body>
//                                 </Card>
//                             </Col>
//                             <Col xs={12} sm={6} md={4} className="mb-4">

//                                 <Card style={cardStyle} className='B320'>
//                                     <Card.Img
//                                         variant="top"
//                                         src={B320}
//                                         style={cardImageStyle}
//                                         onMouseEnter={handleMouseEnter}
//                                         onMouseLeave={handleMouseLeave}
//                                     />
//                                     <Card.Body>
//                                         <Card.Title>District 320B</Card.Title>
//                                         <Card.Text>District 320 B -Ranga Reddy and Hyderabad <a href='#'><b>READ MORE</b></a></Card.Text>
//                                     </Card.Body>
//                                 </Card>
//                             </Col>
//                             <Col xs={12} sm={6} md={4} className="mb-4">

//                                 <Card style={cardStyle} className='C320'>
//                                     <Card.Img
//                                         variant="top"
//                                         src={C320}
//                                         style={cardImageStyle}
//                                         onMouseEnter={handleMouseEnter}
//                                         onMouseLeave={handleMouseLeave}
//                                     />
//                                     <Card.Body>
//                                         <Card.Title>District 320C</Card.Title>
//                                         <Card.Text>District 320 C -Ranga Reddy and Hyderabad <a href='#'><b>READ MORE</b></a></Card.Text>
//                                     </Card.Body>
//                                 </Card>
//                             </Col>
//                         </Row>
//                         <Row>
//                             <Col xs={12} sm={6} md={4} className="mb-4">

//                                 <Card style={cardStyle} className='D320'>
//                                     <Card.Img
//                                         variant="top"
//                                         src={D320}
//                                         style={cardImageStyle}
//                                         onMouseEnter={handleMouseEnter}
//                                         onMouseLeave={handleMouseLeave}
//                                     />
//                                     <Card.Body>
//                                         <Card.Title>District 320D</Card.Title>
//                                         <Card.Text>Adilabad,Nizamabad,Medak,RR and Hyderabad <a href='#'><b>READ MORE</b></a></Card.Text>
//                                     </Card.Body>
//                                 </Card>
//                             </Col>
//                             <Col xs={12} sm={6} md={4} className="mb-4">

//                                 <Card style={cardStyle}>
//                                     <Card.Img
//                                         variant="top"
//                                         src='/'
//                                         style={{ backgroundColor: "rgb(90, 132, 172)" }}
//                                         onMouseEnter={handleMouseEnter}
//                                         onMouseLeave={handleMouseLeave}
//                                     />
//                                     <Card.Body style={{ backgroundColor: "rgb(90, 132, 172)" }}>
//                                         <Card.Title>District 320E</Card.Title>
//                                         <Card.Text >District 320 E -Nalagonda and Khammam <a href='#'><b>READ MORE</b></a></Card.Text>
//                                     </Card.Body>
//                                 </Card>
//                             </Col>
//                             <Col xs={12} sm={6} md={4} className="mb-4">

//                                 <Card style={cardStyle} className='F320'>
//                                     <Card.Img
//                                         variant="top"
//                                         src={F320}
//                                         style={cardImageStyle}
//                                         onMouseEnter={handleMouseEnter}
//                                         onMouseLeave={handleMouseLeave}
//                                     />
//                                     <Card.Body>
//                                         <Card.Title>District 320F</Card.Title>
//                                         <Card.Text>District 320 F -Warangal <a href='#'><b>READ MORE</b></a></Card.Text>
//                                     </Card.Body>
//                                 </Card>
//                             </Col>
//                         </Row>
//                         <Row>
//                             <Col xs={12} sm={6} md={4} className="mb-4">

//                                 <Card style={cardStyle} >
//                                     <Card.Img
//                                         variant="top"
//                                         src='/'
//                                         style={{ backgroundColor: "rgb(90, 132, 172)" }}
//                                         onMouseEnter={handleMouseEnter}
//                                         onMouseLeave={handleMouseLeave}
//                                     />
//                                     <Card.Body style={{ backgroundColor: "rgb(90, 132, 172)" }}>
//                                         <Card.Title >District 320G</Card.Title>
//                                         <Card.Text>District 320 G -Adilabad and Karimnagar <a href='#'><b>READ MORE</b></a></Card.Text>
//                                     </Card.Body>
//                                 </Card>
//                             </Col>
//                         </Row>
//                     </CardGroup>
//                 </div>
//             </center><br /><br /><br />
//             <div>
//                 <p style={{ fontSize: '2.0rem', fontWeight: 'bold', color: "black" }}>Latest NEWS</p>
//             </div><br /><br />
//             <div>
//                 <Carousel controls indicators id="bootcarousel" >
//                     <Carousel.Item>
//                         <CardGroup style={{ gap: '0.2rem', marginLeft: '10%' }}>
//                             <Row>
//                                 <Col>
//                                     <Card className="w-100 h-100" style={{ backgroundColor: 'lightgray', lineHeight: '2rem' }}>
//                                         <Card.Img
//                                             variant="top"
//                                             src={lionsimg3}
//                                             style={{ height: '100%', objectFit: 'cover', }}
//                                         />
//                                         <Card.Body>
//                                             <div className="info">
//                                                 <div className="cats">
//                                                     <a href="#">.Global Action Team (GAT) Leadership</a><br />
//                                                     <a href="#">.Clubs Are at the Center of the Action</a>
//                                                 </div>
//                                                 <h6>
//                                                     <a href="">Friendly bachelor entrance</a>
//                                                 </h6>
//                                                 <p style={{ color: "black", textAlign: "justify" }}>
//                                                     The Global Action Team (GAT) puts the entire Lions network to work for your club. And teamwork is the key—it brings the entire GLT, GMT, and GST together to support your club. It’s a bottoms-up, whole-club approach that can energize every facet of your club. Help is all around you.
//                                                 </p>
//                                                 <div className="meta">
//                                                     <a href="#">Read More</a>
//                                                 </div>
//                                             </div>
//                                         </Card.Body>
//                                     </Card>
//                                 </Col>
//                                 <Col>
//                                     <Card className="w-100 h-100" style={{ backgroundColor: 'lightgray', lineHeight: '2rem' }}>
//                                         <Card.Img
//                                             variant="top"
//                                             src={lionsimg}
//                                             style={{ height: '100%', objectFit: 'cover' }}
//                                         />
//                                         <Card.Body>
//                                             <div className="info">
//                                                 <div className="cats">
//                                                     <a href="#">.Where there’s a need, there’s a Leo</a><br />
//                                                     <a href="#">“Leadership, Experience, Opportunity.”</a>
//                                                 </div>
//                                                 <h6>
//                                                     <a href="#">That’s what makes a Leo. As the youngest members of Lions Clubs International</a>
//                                                 </h6>
//                                                 <p style={{ color: "black", textAlign: "justify" }}>
//                                                     Leos embody the best qualities of our incredible organization. They are devoted young people who realize the power of action. Together, Leos and Lions form a powerful partnership — one of mutual respect where Lions learn

//                                                 </p>
//                                                 <div className="meta">
//                                                     <a href="#">Read More</a>
//                                                 </div>
//                                             </div>
//                                         </Card.Body>
//                                     </Card>
//                                 </Col>
//                             </Row>
//                         </CardGroup>
//                     </Carousel.Item>
//                     <Carousel.Item>
//                         <CardGroup style={{ gap: '0.2rem', marginLeft: '10%' }}>
//                             <Row>
//                                 <Col>
//                                     <Card className="w-100 h-100" style={{ backgroundColor: 'lightgray', lineHeight: '2rem' }}>
//                                         <Card.Img
//                                             variant="top"
//                                             src={lionsimg1}
//                                             style={{ height: '100%', objectFit: 'cover' }}
//                                         />
//                                         <Card.Body>
//                                             <div className="info">
//                                                 <div className='cats'>
//                                                     <a href="#" className='none'>.The Foundation of Service</a><br />
//                                                     <a href="#" className='none'>.Impacting lives through humanitarian service projects and grants.</a>
//                                                 </div>
//                                                 <h6>
//                                                     <a href="#">Lions Clubs International Foundation</a>
//                                                 </h6>
//                                                 <p style={{ color: "black", textAlign: "justify" }}>
//                                                     The story of LCIF is epic—filled with unlimited compassion and tireless support of Lions service. Founded in 1968, the mission of LCIF is "To support the efforts of Lions clubs and partners in serving communities locally and globally, giving hope and impacting lives
//                                                     {/* through humanitarian service projects and grants. */}
//                                                 </p>
//                                                 <div className="meta">
//                                                     <a href="#">Read More</a>
//                                                 </div>
//                                             </div>
//                                         </Card.Body>
//                                     </Card>
//                                 </Col>
//                                 <Col>
//                                     <Card className="w-100 h-100" style={{ backgroundColor: 'lightgray', lineHeight: '2rem' }}>
//                                         <Card.Img
//                                             variant="top"
//                                             src={lionsimg2}
//                                             style={{ height: '100%', objectFit: 'cover' }}
//                                         />
//                                         <Card.Body>
//                                             <div className="info">
//                                                 <div className="cats">
//                                                     <a href="#">.The History of Lions Quest</a><br />
//                                                     <a href="#">.The ideas behind Lions Quest date back to 1975</a>
//                                                 </div>
//                                                 <h6>
//                                                     <a href="#">LCIF</a>
//                                                 </h6>
//                                                 <p style={{ color: "black", textAlign: "justify" }}>
//                                                     The ideas behind Lions Quest date back to 1975, when a teenager named Rick Little set out on a “quest” to help other young people develop the skills and strength of character needed to succeed as adults. Rick conducted a survey of over 2,000 high school students
//                                                     {/* to determine the issues that concerned them most and consulted experienced teachers who suggested including a teacher workshop which would serve as a classroom model. The program was so successful at the high school level that soon middle and elementary schools were asking for age-appropriate positive youth development programs. Little eventually founded and served as chief executive officer of the International Youth Foundation. */}
//                                                 </p>
//                                                 <div className="meta">
//                                                     <a href="#">Read More</a>
//                                                 </div>
//                                             </div>
//                                         </Card.Body>
//                                     </Card>
//                                 </Col>
//                             </Row>
//                         </CardGroup>
//                     </Carousel.Item>
//                 </Carousel>
//             </div>
//             <Footer />


//         </div>
//     )
// }

// export default Home









// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import TopNavbar from '../Navbar/TopNavbar';
// import Footer from '../Footer/Footer';



// const districts = ["320A", "320B", "320C", "320D", "320E", "320F", "320G", "320H"];

// const districtDescriptions = {
//     "320A": "Raichur, Bidar, MahabubNagar, RR",
//     "320B": "Ranga Reddy and Hyderabad",
//     "320C": "Ranga Reddy and Hyderabad",
//     "320D": "Adilabad, Nizamabad, Medak, RR and Hyderabad",
//     "320E": "Nalagonda and Khammam",
//     "320F": "Warangal",
//     "320G": "Adilabad and Karimnagar",
//     "320H": "Island Region",
// };



// const banners = [
//     {
//         id: 1,
//         image: "https://images.unsplash.com/photo-1593113598332-cd288d649433?w=1440&h=580&fit=crop&auto=format",
//         imageAlt: "Volunteers distributing humanitarian aid",
//         tag: "Community Service",
//         headline: "Serving Those\nWho Need Us Most",
//         sub: "MD 320's 1,200+ clubs mobilize thousands of volunteers each year to deliver food, shelter, and hope to communities across the region.",
//         cta: { label: "Get Involved", to: "/contact" },
//         ctaSecondary: { label: "Find Your District", to: "/multiple-districts" },
//         align: "left",
//         overlayStrength: "heavy",
//     },
//     {
//         id: 2,
//         image: "https://images.unsplash.com/photo-1770221798098-d8a7f7517f68?w=1440&h=580&fit=crop&auto=format",
//         imageAlt: "Eye care medical outreach examination",
//         tag: "SightFirst Initiative",
//         headline: "Restoring Sight,\nRestoring Lives",
//         sub: "Through Lions' SightFirst program, District 320 has provided free eye examinations and corrective lenses to over 200,000 people.",
//         cta: { label: "Learn More", to: "/international" },
//         align: "left",
//         overlayStrength: "heavy",
//     },
//     {
//         id: 3,
//         image: "https://images.unsplash.com/photo-1558008258-3256797b43f3?w=1440&h=580&fit=crop&auto=format",
//         imageAlt: "Youth leadership conference audience",
//         tag: "Youth Development",
//         headline: "Building Tomorrow's\nLeaders Today",
//         sub: "Leo Clubs and Lions Quest programs across MD 320 empower young people with the skills, values, and confidence to lead in their communities.",
//         cta: { label: "Explore Programs", to: "/international" },
//         ctaSecondary: { label: "Contact Us", to: "/contact" },
//         align: "left",
//         overlayStrength: "heavy",
//     },
//     {
//         id: 4,
//         image: "https://images.unsplash.com/photo-1599059813005-11265ba4b4ce?w=1440&h=580&fit=crop&auto=format",
//         imageAlt: "Volunteers sorting food donations",
//         tag: "Disaster Relief",
//         headline: "First to Respond\nWhen Disaster Strikes",
//         sub: "Coordinating with LCIF, MD 320 has delivered over $4.2 million in disaster relief assistance to affected families across the region.",
//         cta: { label: "Donate & Support", to: "/contact" },
//         align: "left",
//         overlayStrength: "heavy",
//     },
//     {
//         id: 5,
//         image: "https://images.unsplash.com/photo-1521574778337-d962ef81733d?w=1440&h=580&fit=crop&auto=format",
//         imageAlt: "Group of people at community gathering",
//         tag: "Annual Convention 2025",
//         headline: "MD 320 Annual\nConvention — Join Us",
//         sub: "Register now for the MD 320 Annual Convention, September 12–14, 2025. Three days of service, fellowship, and leadership in action.",
//         cta: { label: "Register Now", to: "/contact" },
//         ctaSecondary: { label: "View Districts", to: "/multiple-districts" },
//         align: "center",
//         overlayStrength: "heavy",
//     },
//     {
//         id: 6,
//         image: "https://images.unsplash.com/photo-1628717341663-0007b0ee2597?w=1440&h=580&fit=crop&auto=format",
//         imageAlt: "Volunteer handing out supplies",
//         tag: "Multiple District 320",
//         headline: "Eight Districts.\nOne Mission.",
//         sub: "From 320A to 320H, our eight districts work in unison to deliver impactful humanitarian service across every corner of the region.",
//         cta: { label: "Explore MD 320", to: "/multiple-districts" },
//         align: "center",
//         overlayStrength: "heavy",
//     },
// ];

// const overlayGradients = {
//     light: "linear-gradient(to right, rgba(0,0,0,0.3), rgba(0,0,0,0.1), transparent)",
//     medium: "linear-gradient(to right, rgba(0,0,0,0.6), rgba(0,0,0,0.3), transparent)",
//     heavy: "linear-gradient(to right, rgba(0,0,0,0.75), rgba(0,0,0,0.45), rgba(0,0,0,0.1))",
// };

// export default function Home() {
//     const [windowWidth, setWindowWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);

//     useEffect(() => {
//         const handleResize = () => setWindowWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     const isLG = windowWidth >= 1024;
//     const isMD = windowWidth >= 768;
//     const isSM = windowWidth >= 640;

//     // Banner Carousel State
//     const [current, setCurrent] = useState(0);
//     const [paused, setPaused] = useState(false);
//     const [transitioning, setTransitioning] = useState(false);
//     const timerRef = useRef(null);

//     const goTo = useCallback((index) => {
//         if (transitioning) return;
//         setTransitioning(true);
//         setTimeout(() => {
//             setCurrent(index);
//             setTransitioning(false);
//         }, 200);
//     }, [transitioning]);

//     const next = useCallback(() => {
//         goTo((current + 1) % banners.length);
//     }, [current, goTo]);

//     const prev = useCallback(() => {
//         goTo((current - 1 + banners.length) % banners.length);
//     }, [current, goTo]);

//     useEffect(() => {
//         if (paused) return;
//         timerRef.current = setInterval(next, 5000);
//         return () => { if (timerRef.current) clearInterval(timerRef.current); }
//     }, [paused, next]);

//     const banner = banners[current];







//     const [multipleDistrict, setMultipleDistrict] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchMultipleDistricts = async () => {
//             try {
//                 const response = await fetch(
//                     "https://api.lionsmd320.org/pages/api/multiple-districts"
//                 );

//                 if (!response.ok) {
//                     throw new Error("Failed to fetch multiple district data");
//                 }

//                 const result = await response.json();

//                 setMultipleDistrict(result?.multipleDistricts?.[0] || null);
//             } catch (err) {
//                 console.error("Multiple District API Error:", err);
//                 setError(err.message);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchMultipleDistricts();
//     }, []);

//     if (loading) {
//         return (
//             <div style={{ backgroundColor: "#005090", padding: "30px 16px", color: "#fff", textAlign: "center", }}>Loading...</div>
//         );
//     }

//     if (error || !multipleDistrict) {
//         return (
//             <div style={{ backgroundColor: "#005090", padding: "30px 16px", color: "#fff", textAlign: "center", }}>Unable to load statistics.</div>
//         );
//     }

//     const stats = [
//         {
//             value: multipleDistrict.districts,
//             label: "Districts",
//         },
//         {
//             value: Number(multipleDistrict.total_clubs).toLocaleString(),
//             label: "Clubs",
//         },
//         {
//             value: Number(multipleDistrict.total_members).toLocaleString(),
//             label: "Members",
//         },
//         {
//             value: multipleDistrict.fiscal_year,
//             label: "Fiscal Year",
//         },
//     ];

//     return (
//         <>
//             <TopNavbar />
//             <div style={{ width: "100%", overflowX: "hidden", fontFamily: "sans-serif" }}>

//                 {/* BannerCarousel Section */}
//                 <section style={{ position: "relative", width: "100%", overflow: "hidden", backgroundColor: "#003a6e", height: windowWidth < 640 ? "420px" : windowWidth < 1024 ? "480px" : "580px" }} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
//                     <div style={{ position: "absolute", inset: 0, backgroundImage: `url(${banner.image})`, backgroundSize: "cover", backgroundPosition: "center", opacity: transitioning ? 0 : 1, transition: "opacity 0.5s ease-in-out" }} role="img" aria-label={banner.imageAlt} />
//                     <div style={{ position: "absolute", inset: 0, background: overlayGradients[banner.overlayStrength] }} />
//                     <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, height: "96px", background: "linear-gradient(to top, rgba(0,0,0,0.4), transparent)" }} />

//                     <div style={{ position: "relative", height: "100%", maxWidth: "1280px", margin: "0 auto", padding: isLG ? "0 64px" : isSM ? "0 40px" : "0 24px", display: "flex", flexDirection: "column", justifyContent: "center", opacity: transitioning ? 0 : 1, transition: "opacity 0.5s ease-in-out", alignItems: banner.align === "center" ? "center" : "flex-start", textAlign: banner.align === "center" ? "center" : "left" }}>
//                         <div style={{ maxWidth: "672px", width: "100%", margin: banner.align === "center" ? "0 auto" : "0" }}>
//                             <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
//                                 <span style={{ width: "24px", height: "1px", backgroundColor: "#FFD500" }} />
//                                 <span style={{ color: "#FFD500", fontSize: "11px", fontWeight: "bold", letterSpacing: "0.18em", textTransform: "uppercase" }}>{banner.tag}</span>
//                             </div>

//                             <h2 style={{ fontFamily: "inherit", fontWeight: 800, color: "#ffffff", lineHeight: 1.08, marginBottom: "20px", fontSize: windowWidth < 640 ? "1.75rem" : windowWidth < 1024 ? "2.5rem" : "3rem", whiteSpace: "pre-line" }}>{banner.headline}</h2>
//                             <p style={{ color: "rgba(255, 255, 255, 0.8)", fontSize: isSM ? "1rem" : "0.875rem", lineHeight: 1.6, marginBottom: "32px", maxWidth: "512px", margin: banner.align === "center" ? "0 auto 32px auto" : "0 0 32px 0" }}>{banner.sub}</p>

//                             <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: banner.align === "center" ? "center" : "flex-start" }}>
//                                 {banner.cta && (
//                                     <Link to={banner.cta.to} style={{ backgroundColor: "#FFD500", color: "#0067B1", fontWeight: "bold", padding: "10px 24px", borderRadius: "6px", fontSize: "0.875rem", letterSpacing: "0.025em", textDecoration: "none", boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)", transition: "background-color 0.2s" }}>{banner.cta.label}</Link>
//                                 )}
//                                 {banner.ctaSecondary && (
//                                     <Link to={banner.ctaSecondary.to} style={{ backgroundColor: "rgba(255, 255, 255, 0.15)", backdropFilter: "blur(4px)", border: "1px solid rgba(255, 255, 255, 0.4)", color: "#ffffff", fontWeight: 600, padding: "10px 24px", borderRadius: "6px", fontSize: "0.875rem", letterSpacing: "0.025em", textDecoration: "none" }}>
//                                         {banner.ctaSecondary.label}
//                                     </Link>
//                                 )}
//                             </div>
//                         </div>
//                     </div>

//                     <button onClick={prev} aria-label="Previous banner" style={{ position: "absolute", left: isSM ? "24px" : "12px", top: "50%", transform: "translateY(-50%)", width: isSM ? "48px" : "40px", height: isSM ? "48px" : "40px", borderRadius: "50%", backgroundColor: "rgba(0, 0, 0, 0.3)", border: "1px solid rgba(255, 255, 255, 0.2)", color: "#ffffff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", backdropFilter: "blur(4px)" }}>
//                         <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
//                         </svg>
//                     </button>

//                     <button onClick={next} aria-label="Next banner" style={{ position: "absolute", right: isSM ? "24px" : "12px", top: "50%", transform: "translateY(-50%)", width: isSM ? "48px" : "40px", height: isSM ? "48px" : "40px", borderRadius: "50%", backgroundColor: "rgba(0, 0, 0, 0.3)", border: "1px solid rgba(255, 255, 255, 0.2)", color: "#ffffff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", backdropFilter: "blur(4px)" }}>
//                         <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
//                         </svg>
//                     </button>
//                 </section>

//                 {/* International President Feature Banner */}
//                 <section style={{ backgroundColor: "#ffffff", padding: isSM ? "48px 0" : "32px 0", borderBottom: "1px solid #f3f4f6" }}>
//                     <div style={{ maxWidth: "1280px", margin: "0 auto", padding: isLG ? "0 32px" : isSM ? "0 24px" : "0 16px" }}>
//                         <div style={{ backgroundColor: "#f0f7ff", borderRadius: "16px", padding: isLG ? "48px" : isSM ? "32px" : "20px", border: "1px solid #dceeff", position: "relative", overflow: "hidden" }}>
//                             <div style={{ maxWidth: "768px", position: "relative", zIndex: 10 }}>

//                                 <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", backgroundColor: "rgba(255, 213, 0, 0.3)", border: "1px solid rgba(255, 213, 0, 0.5)", borderRadius: "9999px", padding: "4px 12px", marginBottom: "16px" }}>
//                                     <span style={{ color: "#0067B1", fontSize: "11px", fontWeight: "bold", letterSpacing: "0.1em", textTransform: "uppercase" }}>Diversity Bridges All Divides</span>
//                                 </div>
//                                 <h2 style={{ fontSize: isLG ? "2.25rem" : isSM ? "1.75rem" : "1.35rem", fontWeight: 800, color: "#0067B1", lineHeight: 1.2, marginBottom: "16px" }}>
//                                     Creating Harmony Through Services With International President, Dr. Jung-Yul Choi
//                                 </h2>
//                                 <p style={{ color: "#374151", fontSize: isLG ? "1.125rem" : isSM ? "1rem" : "0.938rem", lineHeight: 1.7, marginBottom: "24px" }}>
//                                     <strong>Hard work:</strong> The importance of giving your all with consistency, vision, and passion. Never allowing a crisis to go unserved. These are the values passed on by a loving mother to her son - 103rd International President Dr. Jung-Yul Choi. As a member of the Busan Jae-IL Lions Club in the Republic of Korea for over 40 years, international president Choi leads by example. His career and life have been defined by the work ethic instilled in him as a child, along with a passion to bridge differences, connect people, and embrace diversity to create harmony for all.
//                                 </p>

//                             </div>
//                         </div>
//                     </div>
//                 </section>

//                 {/* Hero Section */}
//                 <section style={{ position: "relative", backgroundColor: "#0067B1", overflow: "hidden", minHeight: "520px" }}>
//                     <div style={{ position: "absolute", inset: 0, opacity: 0.07, backgroundImage: "repeating-linear-gradient(0deg, #fff 0px, #fff 1px, transparent 1px, transparent 40px), repeating-linear-gradient(90deg, #fff 0px, #fff 1px, transparent 1px, transparent 40px)" }} />

//                     <div style={{ position: "relative", maxWidth: "1280px", margin: "0 auto", padding: isLG ? "112px 32px 80px 32px" : "80px 16px", zIndex: 10 }}>
//                         <div style={{ maxWidth: "672px" }}>
//                             <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", backgroundColor: "rgba(255, 213, 0, 0.2)", border: "1px solid rgba(255, 213, 0, 0.4)", borderRadius: "9999px", padding: "6px 16px", marginBottom: "24px" }}>
//                                 <div style={{ width: "6px", height: "6px", backgroundColor: "#FFD500", borderRadius: "50%" }} />
//                                 <span style={{ color: "#FFD500", fontSize: "12px", fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase" }}>Lions Clubs International</span>
//                             </div>
//                             <h1 style={{ fontSize: isLG ? "3.75rem" : "3rem", fontWeight: 800, color: "#ffffff", lineHeight: 1.05, marginBottom: "24px", letterSpacing: "-0.025em" }}>
//                                 Welcome to<br />
//                                 <span style={{ color: "#FFD500" }}>Multiple District 320</span>
//                             </h1>
//                             <p style={{ color: "rgba(255, 255, 255, 0.8)", fontSize: "1.125rem", lineHeight: 1.7, marginBottom: "40px", maxWidth: "576px" }}>
//                                 Uniting eight districts across the region to serve communities, empower members, and build a stronger future together through volunteerism and leadership.
//                             </p>
//                             <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
//                                 <Link to="/multiple-districts" style={{ backgroundColor: "#ffffff", color: "#0067B1", fontWeight: "bold", padding: "12px 28px", borderRadius: "6px", letterSpacing: "0.025em", textDecoration: "none", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)" }}>
//                                     Explore MD 320
//                                 </Link>
//                                 <Link to="/upload" style={{ backgroundColor: "#FFD500", color: "#0067B1", fontWeight: "bold", padding: "12px 28px", borderRadius: "6px", letterSpacing: "0.025em", textDecoration: "none", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)" }}>
//                                     Upload Document
//                                 </Link>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Stats Bar */}
//                     <div style={{ position: "relative", backgroundColor: "#005090", borderTop: "1px solid rgba(255, 255, 255, 0.1)", }}>
//                         <div style={{ maxWidth: "1280px", margin: "0 auto", padding: isLG ? "20px 32px" : "20px 16px", }}>
//                             <div style={{ display: "grid", gridTemplateColumns: isSM ? "repeat(4, minmax(0, 1fr))" : "repeat(2, minmax(0, 1fr))", gap: "24px", }}>
//                                 {stats.map((stat) => (
//                                     <div key={stat.label} style={{ textAlign: "center", }}>
//                                         <div style={{ fontSize: "1.5rem", fontWeight: 800, color: "#FFD500", }}>{stat.value}</div>
//                                         <div style={{ color: "rgba(255, 255, 255, 0.6)", fontSize: "0.75rem", letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 500, marginTop: "2px", }}>{stat.label}</div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>
//                 </section>



//                 {/* About MD 320 */}
//                 <section style={{ padding: "80px 0", backgroundColor: "#ffffff" }}>
//                     <div style={{ maxWidth: "1280px", margin: "0 auto", padding: isLG ? "0 32px" : "0 16px" }}>
//                         <div style={{ display: "grid", gridTemplateColumns: isLG ? "repeat(2, minmax(0, 1fr))" : "minmax(0, 1fr)", gap: "64px", alignItems: "center" }}>
//                             <div>
//                                 <span style={{ color: "#0067B1", fontSize: "12px", fontWeight: "bold", letterSpacing: "0.1em", textTransform: "uppercase", borderBottom: "2px solid #FFD500", paddingBottom: "4px" }}>About MD 320</span>
//                                 <h2 style={{ fontSize: "2.25rem", fontWeight: 800, color: "#0067B1", marginTop: "20px", marginBottom: "24px", lineHeight: 1.2 }}>
//                                     A Legacy of Service<br />and Leadership
//                                 </h2>
//                                 <p style={{ color: "#4b5563", lineHeight: 1.7, marginBottom: "20px" }}>
//                                     Multiple District 320 is a proud member of Lions Clubs International, the world's largest service organization. Our eight districts span a diverse region united by a common mission: to serve those in need and foster goodwill in our communities.
//                                 </p>
//                                 <p style={{ color: "#4b5563", lineHeight: 1.7, marginBottom: "32px" }}>
//                                     With over 1,200 clubs and 48,000 active members, MD 320 coordinates service initiatives, youth programs, and humanitarian efforts that make a measurable difference in people's lives every single day.
//                                 </p>
//                                 <Link to="/international" style={{ display: "inline-flex", alignItems: "center", gap: "8px", color: "#0067B1", fontWeight: 600, fontSize: "0.875rem", textDecoration: "none" }}>
//                                     Learn about our international connection →
//                                 </Link>
//                             </div>
//                             <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "16px" }}>
//                                 {[
//                                     { icon: "👁️", title: "Vision Missions", desc: "Free eye care and glasses for those in need" },
//                                     { icon: "🌍", title: "Humanitarian Aid", desc: "Disaster relief and emergency support" },
//                                     { icon: "🎓", title: "Youth Programs", desc: "Leo Clubs and youth leadership development" },
//                                     { icon: "🤝", title: "Community Service", desc: "Local initiatives and volunteer opportunities" },
//                                 ].map((item) => (
//                                     <div key={item.title} style={{ backgroundColor: "#f0f7ff", borderRadius: "12px", padding: "20px", border: "1px solid #dceeff" }}>
//                                         <div style={{ fontSize: "1.5rem", marginBottom: "12px" }}>{item.icon}</div>
//                                         <h3 style={{ color: "#0067B1", fontWeight: "bold", fontSize: "0.875rem", marginBottom: "4px" }}>{item.title}</h3>
//                                         <p style={{ color: "#6b7280", fontSize: "0.75rem", lineHeight: 1.6 }}>{item.desc}</p>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>
//                 </section>

//                 {/* Quick Navigation */}
//                 <section style={{ padding: "64px 0", backgroundColor: "#f9fafb" }}>
//                     <div style={{ maxWidth: "1280px", margin: "0 auto", padding: isLG ? "0 32px" : "0 16px" }}>
//                         <div style={{ textAlign: "center", marginBottom: "40px" }}>
//                             <span style={{ color: "#0067B1", fontSize: "12px", fontWeight: "bold", letterSpacing: "0.1em", textTransform: "uppercase", borderBottom: "2px solid #FFD500", paddingBottom: "4px" }}>Explore</span>
//                             <h2 style={{ fontSize: "1.875rem", fontWeight: 800, color: "#0067B1", marginTop: "20px" }}>Quick Navigation</h2>
//                         </div>
//                         <div style={{ display: "grid", gridTemplateColumns: isMD ? "repeat(3, minmax(0, 1fr))" : "minmax(0, 1fr)", gap: "24px" }}>
//                             {[
//                                 { to: "/international", title: "International", desc: "Connect with Lions Clubs International for global programs, resources, and initiatives.", bg: "#0067B1" },
//                                 { to: "/multiple-districts", title: "Multiple Districts", desc: "Explore all eight districts of MD 320 and find your local Lions community.", bg: "#004f8a" },
//                                 { to: "/contact", title: "Contact", desc: "Reach out to MD 320 headquarters for information, support, or membership inquiries.", bg: "#003d70" },
//                             ].map((card) => (
//                                 <Link key={card.to} to={card.to} style={{ backgroundColor: card.bg, color: "#ffffff", borderRadius: "12px", padding: "32px", textDecoration: "none", position: "relative", overflow: "hidden", display: "block", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)" }}>
//                                     <h3 style={{ fontWeight: 800, fontSize: "1.25rem", marginBottom: "12px" }}>{card.title}</h3>
//                                     <p style={{ color: "rgba(255, 255, 255, 0.75)", fontSize: "0.875rem", lineHeight: 1.6, marginBottom: "16px" }}>{card.desc}</p>
//                                     <span style={{ color: "#FFD500", fontSize: "0.75rem", fontWeight: "bold", letterSpacing: "0.05em", textTransform: "uppercase" }}>Learn More →</span>
//                                 </Link>
//                             ))}
//                         </div>
//                     </div>
//                 </section>

//                 {/* District Overview */}
//                 <section style={{ padding: "80px 0", backgroundColor: "#ffffff" }}>
//                     <div style={{ maxWidth: "1280px", margin: "0 auto", padding: isLG ? "0 32px" : "0 16px" }}>
//                         <div style={{ display: "flex", flexDirection: isSM ? "row" : "column", justifyContent: "space-between", alignItems: isSM ? "flex-end" : "flex-start", gap: "16px", marginBottom: "48px" }}>
//                             <div>
//                                 <span style={{ color: "#0067B1", fontSize: "12px", fontWeight: "bold", letterSpacing: "0.1em", textTransform: "uppercase", borderBottom: "2px solid #FFD500", paddingBottom: "4px" }}>Our Districts</span>
//                                 <h2 style={{ fontSize: "1.875rem", fontWeight: 800, color: "#0067B1", marginTop: "20px" }}>District Overview</h2>
//                             </div>
//                             <Link to="/multiple-districts" style={{ color: "#0067B1", fontWeight: 600, fontSize: "0.875rem", textDecoration: "none" }}>
//                                 View all districts →
//                             </Link>
//                         </div>
//                         <div style={{ display: "grid", gridTemplateColumns: isLG ? "repeat(4, minmax(0, 1fr))" : isMD ? "repeat(2, minmax(0, 1fr))" : "minmax(0, 1fr)", gap: "20px" }}>
//                             {districts.map((d) => (
//                                 <Link key={d} to={`/district/${d.toLowerCase()}`} style={{ border: "1px solid #f3f4f6", borderRadius: "12px", padding: "24px", textDecoration: "none", display: "flex", flexDirection: "column", justifyContent: "space-between", backgroundColor: "#ffffff" }}>
//                                     <div>
//                                         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}>
//                                             <div style={{ fontSize: "1.875rem", fontWeight: 900, color: "#0067B1" }}>{d}</div>
//                                         </div>
//                                         <div style={{ width: "100%", height: "4px", backgroundColor: "#FFD500", borderRadius: "9999px", marginBottom: "16px" }} />
//                                         <div style={{ color: "#6b7280", fontSize: "0.75rem", fontWeight: 500, letterSpacing: "0.025em", marginBottom: "24px" }}>{districtDescriptions[d]}</div>
//                                     </div>
//                                     <span style={{ fontSize: "0.75rem", fontWeight: "bold", color: "#0067B1", letterSpacing: "0.1em", textTransform: "uppercase" }}>READ MORE →</span>
//                                 </Link>
//                             ))}
//                         </div>
//                     </div>
//                 </section>



//                 {/* CTA Banner */}
//                 <section style={{ padding: "64px 0", backgroundColor: "#FFD500", textAlign: "center" }}>
//                     <div style={{ maxWidth: "1280px", margin: "0 auto", padding: isLG ? "0 32px" : "0 16px" }}>
//                         <h2 style={{ fontSize: "1.875rem", fontWeight: 800, color: "#0067B1", marginBottom: "16px" }}>Ready to Make a Difference?</h2>
//                         <p style={{ color: "rgba(0, 103, 177, 0.7)", fontSize: "1rem", marginBottom: "32px", maxWidth: "512px", margin: "0 auto 32px auto" }}>
//                             Join one of our 1,200+ clubs across MD 320 and become part of the world's largest service organization.
//                         </p>
//                         <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", justifyContent: "center" }}>
//                             <Link to="/contact" style={{ backgroundColor: "#0067B1", color: "#ffffff", fontWeight: "bold", padding: "12px 28px", borderRadius: "6px", textDecoration: "none", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)" }}>
//                                 Get in Touch
//                             </Link>
//                             <Link to="/multiple-districts" style={{ backgroundColor: "#ffffff", color: "#0067B1", fontWeight: "bold", padding: "12px 28px", borderRadius: "6px", textDecoration: "none", boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)" }}>
//                                 Find Your District
//                             </Link>
//                         </div>
//                     </div>
//                 </section>

//             </div>
//             <Footer />
//         </>

//     );
// }




















import React, {
    useState,
    useEffect,
    useCallback,
    useRef
} from 'react';
import { Link } from 'react-router-dom';
import TopNavbar from '../Navbar/TopNavbar';
import Footer from '../Footer/Footer';

const districts = [
    "320A",
    "320B",
    "320C",
    "320D",
    "320E",
    "320F",
    "320G",
    "320H"
];

const districtDescriptions = {
    "320A": "Raichur, Bidar, MahabubNagar, RR",
    "320B": "Ranga Reddy and Hyderabad",
    "320C": "Ranga Reddy and Hyderabad",
    "320D": "Adilabad, Nizamabad, Medak, RR and Hyderabad",
    "320E": "Nalagonda and Khammam",
    "320F": "Warangal",
    "320G": "Adilabad and Karimnagar",
    "320H": "Island Region",
};

export default function Home() {

    /* =========================================================
       RESPONSIVE WIDTH
    ========================================================= */

    const [windowWidth, setWindowWidth] = useState(
        typeof window !== "undefined" ? window.innerWidth : 1200
    );

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const isLG = windowWidth >= 1024;
    const isMD = windowWidth >= 768;
    const isSM = windowWidth >= 640;

    /* =========================================================
       BANNER STATE
    ========================================================= */

    const [banners, setBanners] = useState([]);
    const [bannerLoading, setBannerLoading] = useState(true);
    const [bannerError, setBannerError] = useState(null);

    const [current, setCurrent] = useState(0);
    const [paused, setPaused] = useState(false);

    const carouselRef = useRef(null);

    /* =========================================================
       FETCH DYNAMIC BANNERS
    ========================================================= */

    const fetchBanners = useCallback(async () => {
        setBannerLoading(true);
        setBannerError(null);

        try {
            const response = await fetch(
                "https://api.lionsmd320.org/pages/api/api/uploadbanner"
            );

            if (!response.ok) {
                throw new Error("Failed to fetch banners");
            }

            const data = await response.json();

            const bannerData = Array.isArray(data?.multipleDistricts)
                ? data.multipleDistricts
                : [];

            setBanners(bannerData);

            // Reset carousel when fresh data arrives
            setCurrent(0);

        } catch (error) {
            console.error("Banner API Error:", error);
            setBannerError(error.message);
            setBanners([]);
        } finally {
            setBannerLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchBanners();
    }, [fetchBanners]);

    /* =========================================================
       CAROUSEL NAVIGATION
    ========================================================= */

    const next = useCallback(() => {
        if (!banners.length) return;

        setCurrent((prev) => {
            return (prev + 1) % banners.length;
        });
    }, [banners.length]);

    const prev = useCallback(() => {
        if (!banners.length) return;

        setCurrent((prev) => {
            return (
                (prev - 1 + banners.length) %
                banners.length
            );
        });
    }, [banners.length]);

    const goToSlide = (index) => {
        setCurrent(index);
    };

    /* =========================================================
       AUTO CAROUSEL
    ========================================================= */

    useEffect(() => {
        if (paused || banners.length <= 1) {
            return;
        }

        const timer = setInterval(() => {
            next();
        }, 5000);

        return () => {
            clearInterval(timer);
        };
    }, [paused, next, banners.length]);

    /* =========================================================
       TOUCH / SWIPE SUPPORT
    ========================================================= */

    const touchStartX = useRef(null);
    const touchEndX = useRef(null);

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
        touchEndX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        if (
            touchStartX.current === null ||
            touchEndX.current === null
        ) {
            return;
        }

        const distance =
            touchStartX.current - touchEndX.current;

        const minSwipeDistance = 50;

        if (distance > minSwipeDistance) {
            next();
        }

        if (distance < -minSwipeDistance) {
            prev();
        }

        touchStartX.current = null;
        touchEndX.current = null;
    };

    /* =========================================================
       MULTIPLE DISTRICT API
    ========================================================= */

    const [multipleDistrict, setMultipleDistrict] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMultipleDistricts = async () => {
            try {
                const response = await fetch(
                    "https://api.lionsmd320.org/pages/api/multiple-districts"
                );

                if (!response.ok) {
                    throw new Error(
                        "Failed to fetch multiple district data"
                    );
                }

                const result = await response.json();

                setMultipleDistrict(
                    result?.multipleDistricts?.[0] || null
                );

            } catch (err) {
                console.error(
                    "Multiple District API Error:",
                    err
                );

                setError(err.message);

            } finally {
                setLoading(false);
            }
        };

        fetchMultipleDistricts();
    }, []);

    /* =========================================================
       LOADING
    ========================================================= */

    if (loading) {
        return (
            <div
                style={{
                    backgroundColor: "#005090",
                    padding: "30px 16px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                Loading...
            </div>
        );
    }

    if (error || !multipleDistrict) {
        return (
            <div
                style={{
                    backgroundColor: "#005090",
                    padding: "30px 16px",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                Unable to load statistics.
            </div>
        );
    }

    /* =========================================================
       STATS
    ========================================================= */

    const stats = [
        {
            value: multipleDistrict.districts,
            label: "Districts",
        },
        {
            value: Number(
                multipleDistrict.total_clubs
            ).toLocaleString(),
            label: "Clubs",
        },
        {
            value: Number(
                multipleDistrict.total_members
            ).toLocaleString(),
            label: "Members",
        },
        {
            value: multipleDistrict.fiscal_year,
            label: "Fiscal Year",
        },
    ];

    /* =========================================================
       RENDER
    ========================================================= */

    return (
        <>
            <TopNavbar />

            <div
                style={{
                    width: "100%",
                    overflowX: "hidden",
                    fontFamily: "sans-serif"
                }}
            >

                {/* =====================================================
                    DYNAMIC BANNER CAROUSEL
                ===================================================== */}

                <section
                    style={{
                        position: "relative",
                        width: "100%",
                        overflow: "hidden",
                        backgroundColor: "#003a6e",

                        height:
                            windowWidth < 640
                                ? "420px"
                                : windowWidth < 1024
                                    ? "480px"
                                    : "580px",

                        touchAction: "pan-y"
                    }}

                    onMouseEnter={() => setPaused(true)}
                    onMouseLeave={() => setPaused(false)}

                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                >

                    {/* =================================================
                        LOADING
                    ================================================= */}

                    {bannerLoading && (
                        <div
                            style={{
                                position: "absolute",
                                inset: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#003a6e",
                                color: "#ffffff",
                                zIndex: 20,
                                fontSize: "14px",
                                fontWeight: "600"
                            }}
                        >
                            Loading banners...
                        </div>
                    )}

                    {/* =================================================
                        ERROR
                    ================================================= */}

                    {!bannerLoading &&
                        bannerError && (
                            <div
                                style={{
                                    position: "absolute",
                                    inset: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#003a6e",
                                    color: "#ffffff",
                                    zIndex: 20,
                                    textAlign: "center",
                                    padding: "20px"
                                }}
                            >
                                Unable to load banners.
                            </div>
                        )}

                    {/* =================================================
                        EMPTY
                    ================================================= */}

                    {!bannerLoading &&
                        !bannerError &&
                        banners.length === 0 && (
                            <div
                                style={{
                                    position: "absolute",
                                    inset: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#003a6e",
                                    color: "#ffffff",
                                    zIndex: 20
                                }}
                            >
                                No banners available.
                            </div>
                        )}

                    {/* =================================================
                        HORIZONTAL CAROUSEL
                    ================================================= */}

                    {banners.length > 0 && (
                        <div
                            ref={carouselRef}
                            style={{
                                display: "flex",
                                width: "100%",
                                height: "100%",

                                transform: `translateX(-${current * 100}%)`,

                                transition:
                                    "transform 0.7s cubic-bezier(0.4, 0, 0.2, 1)"
                            }}
                        >

                            {banners.map((item, index) => {

                                const imageUrl =
                                    item.banner_image;

                                const button1 =
                                    item.buttonName1;

                                const button2 =
                                    item.buttonName2;

                                const cta1 =
                                    item.cta;

                                const cta2 =
                                    item.ctaSecondary;

                                return (
                                    <div
                                        key={item.id}
                                        style={{
                                            minWidth: "100%",
                                            width: "100%",
                                            height: "100%",
                                            position: "relative",
                                            flexShrink: 0,
                                            overflow: "hidden"
                                        }}
                                    >

                                        {/* Banner Image */}

                                        <div
                                            style={{
                                                position: "absolute",
                                                inset: 0,

                                                backgroundImage:
                                                    `url("${imageUrl}")`,

                                                backgroundSize:
                                                    "cover",

                                                backgroundPosition:
                                                    "center",

                                                backgroundRepeat:
                                                    "no-repeat"
                                            }}
                                        />

                                        {/* Dark Overlay */}

                                        <div
                                            style={{
                                                position: "absolute",
                                                inset: 0,

                                                background:
                                                    "linear-gradient(to right, rgba(0,0,0,0.78), rgba(0,0,0,0.48), rgba(0,0,0,0.08))"
                                            }}
                                        />

                                        {/* Bottom Overlay */}

                                        <div
                                            style={{
                                                position: "absolute",
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                height: "120px",

                                                background:
                                                    "linear-gradient(to top, rgba(0,0,0,0.5), transparent)"
                                            }}
                                        />

                                        {/* Content */}

                                        <div
                                            style={{
                                                position: "relative",
                                                zIndex: 5,
                                                height: "100%",
                                                maxWidth: "1280px",
                                                margin: "0 auto",

                                                padding:
                                                    isLG
                                                        ? "0 64px"
                                                        : isSM
                                                            ? "0 40px"
                                                            : "0 24px",

                                                display: "flex",
                                                flexDirection:
                                                    "column",

                                                justifyContent:
                                                    "center",

                                                alignItems:
                                                    "flex-start",

                                                textAlign:
                                                    "left"
                                            }}
                                        >

                                            <div
                                                style={{
                                                    maxWidth: "680px",
                                                    width: "100%"
                                                }}
                                            >

                                                {/* TAG */}

                                                <div
                                                    style={{
                                                        display:
                                                            "inline-flex",

                                                        alignItems:
                                                            "center",

                                                        gap: "8px",

                                                        marginBottom:
                                                            "16px"
                                                    }}
                                                >

                                                    <span
                                                        style={{
                                                            width: "24px",
                                                            height: "1px",
                                                            backgroundColor:
                                                                "#FFD500"
                                                        }}
                                                    />

                                                    <span
                                                        style={{
                                                            color:
                                                                "#FFD500",

                                                            fontSize:
                                                                "11px",

                                                            fontWeight:
                                                                "bold",

                                                            letterSpacing:
                                                                "0.18em",

                                                            textTransform:
                                                                "uppercase"
                                                        }}
                                                    >
                                                        {item.tag ||
                                                            "Lions MD 320"}
                                                    </span>

                                                </div>

                                                {/* TITLE */}

                                                <h2
                                                    style={{
                                                        fontWeight: 800,

                                                        color:
                                                            "#ffffff",

                                                        lineHeight:
                                                            1.08,

                                                        margin:
                                                            "0 0 20px 0",

                                                        fontSize:
                                                            windowWidth < 640
                                                                ? "1.75rem"
                                                                : windowWidth < 1024
                                                                    ? "2.5rem"
                                                                    : "3rem",

                                                        whiteSpace:
                                                            "pre-line"
                                                    }}
                                                >
                                                    {item.title}
                                                </h2>

                                                {/* DESCRIPTION */}

                                                <p
                                                    style={{
                                                        color:
                                                            "rgba(255,255,255,0.82)",

                                                        fontSize:
                                                            isSM
                                                                ? "1rem"
                                                                : "0.875rem",

                                                        lineHeight:
                                                            1.6,

                                                        margin:
                                                            "0 0 32px 0",

                                                        maxWidth:
                                                            "560px"
                                                    }}
                                                >
                                                    {item.description}
                                                </p>

                                                {/* BUTTONS */}

                                                {(button1 &&
                                                    cta1) ||
                                                (button2 &&
                                                    cta2) ? (
                                                    <div
                                                        style={{
                                                            display:
                                                                "flex",

                                                            flexWrap:
                                                                "wrap",

                                                            gap: "12px"
                                                        }}
                                                    >

                                                        {/* PRIMARY */}

                                                        {button1 &&
                                                            cta1 && (
                                                                <a
                                                                    href={
                                                                        cta1
                                                                    }

                                                                    style={{
                                                                        display:
                                                                            "inline-flex",

                                                                        alignItems:
                                                                            "center",

                                                                        justifyContent:
                                                                            "center",

                                                                        backgroundColor:
                                                                            "#FFD500",

                                                                        color:
                                                                            "#0067B1",

                                                                        fontWeight:
                                                                            "bold",

                                                                        padding:
                                                                            "10px 24px",

                                                                        borderRadius:
                                                                            "6px",

                                                                        fontSize:
                                                                            "0.875rem",

                                                                        textDecoration:
                                                                            "none",

                                                                        boxShadow:
                                                                            "0 10px 15px -3px rgba(0,0,0,0.1)",

                                                                        transition:
                                                                            "all 0.2s"
                                                                    }}
                                                                >
                                                                    {
                                                                        button1
                                                                    }
                                                                </a>
                                                            )}

                                                        {/* SECONDARY */}

                                                        {button2 &&
                                                            cta2 && (
                                                                <a
                                                                    href={
                                                                        cta2
                                                                    }

                                                                    style={{
                                                                        display:
                                                                            "inline-flex",

                                                                        alignItems:
                                                                            "center",

                                                                        justifyContent:
                                                                            "center",

                                                                        backgroundColor:
                                                                            "rgba(255,255,255,0.15)",

                                                                        backdropFilter:
                                                                            "blur(4px)",

                                                                        border:
                                                                            "1px solid rgba(255,255,255,0.4)",

                                                                        color:
                                                                            "#ffffff",

                                                                        fontWeight:
                                                                            600,

                                                                        padding:
                                                                            "10px 24px",

                                                                        borderRadius:
                                                                            "6px",

                                                                        fontSize:
                                                                            "0.875rem",

                                                                        textDecoration:
                                                                            "none"
                                                                    }}
                                                                >
                                                                    {
                                                                        button2
                                                                    }
                                                                </a>
                                                            )}

                                                    </div>
                                                ) : null}

                                            </div>

                                        </div>

                                    </div>
                                );
                            })}

                        </div>
                    )}

                    {/* =================================================
                        PREVIOUS BUTTON
                    ================================================= */}

                    {banners.length > 1 && (
                        <>
                            <button
                                onClick={prev}
                                aria-label="Previous banner"

                                style={{
                                    position: "absolute",

                                    left:
                                        isSM
                                            ? "24px"
                                            : "12px",

                                    top: "50%",

                                    transform:
                                        "translateY(-50%)",

                                    width:
                                        isSM
                                            ? "48px"
                                            : "40px",

                                    height:
                                        isSM
                                            ? "48px"
                                            : "40px",

                                    borderRadius: "50%",

                                    backgroundColor:
                                        "rgba(0,0,0,0.35)",

                                    border:
                                        "1px solid rgba(255,255,255,0.3)",

                                    color:
                                        "#ffffff",

                                    display:
                                        "flex",

                                    alignItems:
                                        "center",

                                    justifyContent:
                                        "center",

                                    cursor:
                                        "pointer",

                                    backdropFilter:
                                        "blur(4px)",

                                    zIndex: 10
                                }}
                            >

                                <svg
                                    style={{
                                        width: "20px",
                                        height: "20px"
                                    }}

                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2.5}
                                        d="M15 19l-7-7 7-7"
                                    />
                                </svg>

                            </button>

                            {/* =================================================
                                NEXT BUTTON
                            ================================================= */}

                            <button
                                onClick={next}
                                aria-label="Next banner"

                                style={{
                                    position: "absolute",

                                    right:
                                        isSM
                                            ? "24px"
                                            : "12px",

                                    top: "50%",

                                    transform:
                                        "translateY(-50%)",

                                    width:
                                        isSM
                                            ? "48px"
                                            : "40px",

                                    height:
                                        isSM
                                            ? "48px"
                                            : "40px",

                                    borderRadius: "50%",

                                    backgroundColor:
                                        "rgba(0,0,0,0.35)",

                                    border:
                                        "1px solid rgba(255,255,255,0.3)",

                                    color:
                                        "#ffffff",

                                    display:
                                        "flex",

                                    alignItems:
                                        "center",

                                    justifyContent:
                                        "center",

                                    cursor:
                                        "pointer",

                                    backdropFilter:
                                        "blur(4px)",

                                    zIndex: 10
                                }}
                            >

                                <svg
                                    style={{
                                        width: "20px",
                                        height: "20px"
                                    }}

                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2.5}
                                        d="M9 5l7 7-7 7"
                                    />
                                </svg>

                            </button>

                            {/* =================================================
                                DOT NAVIGATION
                            ================================================= */}

                            <div
                                style={{
                                    position: "absolute",
                                    bottom: "22px",
                                    left: 0,
                                    right: 0,
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "8px",
                                    zIndex: 10
                                }}
                            >

                                {banners.map(
                                    (item, index) => (
                                        <button
                                            key={item.id}
                                            onClick={() =>
                                                goToSlide(
                                                    index
                                                )
                                            }

                                            aria-label={`Go to banner ${index + 1}`}

                                            style={{
                                                width:
                                                    current ===
                                                    index
                                                        ? "28px"
                                                        : "8px",

                                                height:
                                                    "8px",

                                                borderRadius:
                                                    "999px",

                                                border:
                                                    "none",

                                                padding: 0,

                                                backgroundColor:
                                                    current ===
                                                    index
                                                        ? "#FFD500"
                                                        : "rgba(255,255,255,0.55)",

                                                cursor:
                                                    "pointer",

                                                transition:
                                                    "all 0.3s ease"
                                            }}
                                        />
                                    )
                                )}

                            </div>

                        </>
                    )}

                </section>


                {/* =====================================================
                    INTERNATIONAL PRESIDENT FEATURE
                ===================================================== */}

                <section
                    style={{
                        backgroundColor: "#ffffff",
                        padding: isSM
                            ? "48px 0"
                            : "32px 0",
                        borderBottom:
                            "1px solid #f3f4f6"
                    }}
                >

                    <div
                        style={{
                            maxWidth: "1280px",
                            margin: "0 auto",
                            padding:
                                isLG
                                    ? "0 32px"
                                    : isSM
                                        ? "0 24px"
                                        : "0 16px"
                        }}
                    >

                        <div
                            style={{
                                backgroundColor:
                                    "#f0f7ff",

                                borderRadius:
                                    "16px",

                                padding:
                                    isLG
                                        ? "48px"
                                        : isSM
                                            ? "32px"
                                            : "20px",

                                border:
                                    "1px solid #dceeff",

                                position:
                                    "relative",

                                overflow:
                                    "hidden"
                            }}
                        >

                            <div
                                style={{
                                    maxWidth:
                                        "768px",

                                    position:
                                        "relative",

                                    zIndex: 10
                                }}
                            >

                                <div
                                    style={{
                                        display:
                                            "inline-flex",

                                        alignItems:
                                            "center",

                                        gap: "8px",

                                        backgroundColor:
                                            "rgba(255,213,0,0.3)",

                                        border:
                                            "1px solid rgba(255,213,0,0.5)",

                                        borderRadius:
                                            "9999px",

                                        padding:
                                            "4px 12px",

                                        marginBottom:
                                            "16px"
                                    }}
                                >

                                    <span
                                        style={{
                                            color:
                                                "#0067B1",

                                            fontSize:
                                                "11px",

                                            fontWeight:
                                                "bold",

                                            letterSpacing:
                                                "0.1em",

                                            textTransform:
                                                "uppercase"
                                        }}
                                    >
                                        Diversity Bridges All Divides
                                    </span>

                                </div>

                                <h2
                                    style={{
                                        fontSize:
                                            isLG
                                                ? "2.25rem"
                                                : isSM
                                                    ? "1.75rem"
                                                    : "1.35rem",

                                        fontWeight:
                                            800,

                                        color:
                                            "#0067B1",

                                        lineHeight:
                                            1.2,

                                        marginBottom:
                                            "16px"
                                    }}
                                >
                                    Creating Harmony Through Services With International President, Dr. Jung-Yul Choi
                                </h2>

                                <p
                                    style={{
                                        color:
                                            "#374151",

                                        fontSize:
                                            isLG
                                                ? "1.125rem"
                                                : isSM
                                                    ? "1rem"
                                                    : "0.938rem",

                                        lineHeight:
                                            1.7,

                                        marginBottom:
                                            "24px"
                                    }}
                                >
                                    <strong>
                                        Hard work:
                                    </strong>{" "}
                                    The importance of giving your all with consistency, vision, and passion. Never allowing a crisis to go unserved. These are the values passed on by a loving mother to her son - 103rd International President Dr. Jung-Yul Choi. As a member of the Busan Jae-IL Lions Club in the Republic of Korea for over 40 years, international president Choi leads by example.
                                </p>

                            </div>

                        </div>

                    </div>

                </section>


                {/* =====================================================
                    HERO SECTION
                ===================================================== */}

                <section
                    style={{
                        position: "relative",
                        backgroundColor:
                            "#0067B1",
                        overflow: "hidden",
                        minHeight: "520px"
                    }}
                >

                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            opacity: 0.07,
                            backgroundImage:
                                "repeating-linear-gradient(0deg, #fff 0px, #fff 1px, transparent 1px, transparent 40px), repeating-linear-gradient(90deg, #fff 0px, #fff 1px, transparent 1px, transparent 40px)"
                        }}
                    />

                    <div
                        style={{
                            position: "relative",
                            maxWidth: "1280px",
                            margin: "0 auto",
                            padding:
                                isLG
                                    ? "112px 32px 80px 32px"
                                    : "80px 16px",
                            zIndex: 10
                        }}
                    >

                        <div
                            style={{
                                maxWidth: "672px"
                            }}
                        >

                            <div
                                style={{
                                    display:
                                        "inline-flex",
                                    alignItems:
                                        "center",
                                    gap: "8px",
                                    backgroundColor:
                                        "rgba(255,213,0,0.2)",
                                    border:
                                        "1px solid rgba(255,213,0,0.4)",
                                    borderRadius:
                                        "9999px",
                                    padding:
                                        "6px 16px",
                                    marginBottom:
                                        "24px"
                                }}
                            >

                                <div
                                    style={{
                                        width: "6px",
                                        height: "6px",
                                        backgroundColor:
                                            "#FFD500",
                                        borderRadius:
                                            "50%"
                                    }}
                                />

                                <span
                                    style={{
                                        color:
                                            "#FFD500",
                                        fontSize:
                                            "12px",
                                        fontWeight:
                                            600,
                                        letterSpacing:
                                            "0.1em",
                                        textTransform:
                                            "uppercase"
                                    }}
                                >
                                    Lions Clubs International
                                </span>

                            </div>

                            <h1
                                style={{
                                    fontSize:
                                        isLG
                                            ? "3.75rem"
                                            : "3rem",
                                    fontWeight:
                                        800,
                                    color:
                                        "#ffffff",
                                    lineHeight:
                                        1.05,
                                    marginBottom:
                                        "24px",
                                    letterSpacing:
                                        "-0.025em"
                                }}
                            >
                                Welcome to
                                <br />

                                <span
                                    style={{
                                        color:
                                            "#FFD500"
                                    }}
                                >
                                    Multiple District 320
                                </span>
                            </h1>

                            <p
                                style={{
                                    color:
                                        "rgba(255,255,255,0.8)",
                                    fontSize:
                                        "1.125rem",
                                    lineHeight:
                                        1.7,
                                    marginBottom:
                                        "40px",
                                    maxWidth:
                                        "576px"
                                }}
                            >
                                Uniting eight districts across the region to serve communities, empower members, and build a stronger future together through volunteerism and leadership.
                            </p>

                            <div
                                style={{
                                    display:
                                        "flex",
                                    flexWrap:
                                        "wrap",
                                    gap:
                                        "16px"
                                }}
                            >

                                <Link
                                    to="/multiple-districts"
                                    style={{
                                        backgroundColor:
                                            "#ffffff",
                                        color:
                                            "#0067B1",
                                        fontWeight:
                                            "bold",
                                        padding:
                                            "12px 28px",
                                        borderRadius:
                                            "6px",
                                        textDecoration:
                                            "none"
                                    }}
                                >
                                    Explore MD 320
                                </Link>

                                <Link
                                    to="/upload"
                                    style={{
                                        backgroundColor:
                                            "#FFD500",
                                        color:
                                            "#0067B1",
                                        fontWeight:
                                            "bold",
                                        padding:
                                            "12px 28px",
                                        borderRadius:
                                            "6px",
                                        textDecoration:
                                            "none"
                                    }}
                                >
                                    Upload Document
                                </Link>

                            </div>

                        </div>

                    </div>


                    {/* STATS */}

                    <div
                        style={{
                            position:
                                "relative",
                            backgroundColor:
                                "#005090",
                            borderTop:
                                "1px solid rgba(255,255,255,0.1)"
                        }}
                    >

                        <div
                            style={{
                                maxWidth:
                                    "1280px",
                                margin:
                                    "0 auto",
                                padding:
                                    isLG
                                        ? "20px 32px"
                                        : "20px 16px"
                            }}
                        >

                            <div
                                style={{
                                    display:
                                        "grid",
                                    gridTemplateColumns:
                                        isSM
                                            ? "repeat(4,minmax(0,1fr))"
                                            : "repeat(2,minmax(0,1fr))",
                                    gap:
                                        "24px"
                                }}
                            >

                                {stats.map(
                                    (stat) => (
                                        <div
                                            key={
                                                stat.label
                                            }
                                            style={{
                                                textAlign:
                                                    "center"
                                            }}
                                        >

                                            <div
                                                style={{
                                                    fontSize:
                                                        "1.5rem",
                                                    fontWeight:
                                                        800,
                                                    color:
                                                        "#FFD500"
                                                }}
                                            >
                                                {
                                                    stat.value
                                                }
                                            </div>

                                            <div
                                                style={{
                                                    color:
                                                        "rgba(255,255,255,0.6)",
                                                    fontSize:
                                                        "0.75rem",
                                                    letterSpacing:
                                                        "0.1em",
                                                    textTransform:
                                                        "uppercase",
                                                    fontWeight:
                                                        500,
                                                    marginTop:
                                                        "2px"
                                                }}
                                            >
                                                {
                                                    stat.label
                                                }
                                            </div>

                                        </div>
                                    )
                                )}

                            </div>

                        </div>

                    </div>

                </section>


                {/* =====================================================
                    ABOUT MD 320
                ===================================================== */}

                <section
                    style={{
                        padding:
                            "80px 0",
                        backgroundColor:
                            "#ffffff"
                    }}
                >

                    <div
                        style={{
                            maxWidth:
                                "1280px",
                            margin:
                                "0 auto",
                            padding:
                                isLG
                                    ? "0 32px"
                                    : "0 16px"
                        }}
                    >

                        <div
                            style={{
                                display:
                                    "grid",
                                gridTemplateColumns:
                                    isLG
                                        ? "repeat(2,minmax(0,1fr))"
                                        : "minmax(0,1fr)",
                                gap:
                                    "64px",
                                alignItems:
                                    "center"
                            }}
                        >

                            <div>

                                <span
                                    style={{
                                        color:
                                            "#0067B1",
                                        fontSize:
                                            "12px",
                                        fontWeight:
                                            "bold",
                                        letterSpacing:
                                            "0.1em",
                                        textTransform:
                                            "uppercase",
                                        borderBottom:
                                            "2px solid #FFD500",
                                        paddingBottom:
                                            "4px"
                                    }}
                                >
                                    About MD 320
                                </span>

                                <h2
                                    style={{
                                        fontSize:
                                            "2.25rem",
                                        fontWeight:
                                            800,
                                        color:
                                            "#0067B1",
                                        marginTop:
                                            "20px",
                                        marginBottom:
                                            "24px",
                                        lineHeight:
                                            1.2
                                    }}
                                >
                                    A Legacy of Service
                                    <br />
                                    and Leadership
                                </h2>

                                <p
                                    style={{
                                        color:
                                            "#4b5563",
                                        lineHeight:
                                            1.7,
                                        marginBottom:
                                            "20px"
                                    }}
                                >
                                    Multiple District 320 is a proud member of Lions Clubs International, the world's largest service organization. Our eight districts span a diverse region united by a common mission: to serve those in need and foster goodwill in our communities.
                                </p>

                                <p
                                    style={{
                                        color:
                                            "#4b5563",
                                        lineHeight:
                                            1.7,
                                        marginBottom:
                                            "32px"
                                    }}
                                >
                                    With over 1,200 clubs and 48,000 active members, MD 320 coordinates service initiatives, youth programs, and humanitarian efforts that make a measurable difference in people's lives every single day.
                                </p>

                                <Link
                                    to="/international"
                                    style={{
                                        color:
                                            "#0067B1",
                                        fontWeight:
                                            600,
                                        fontSize:
                                            "0.875rem",
                                        textDecoration:
                                            "none"
                                    }}
                                >
                                    Learn about our international connection →
                                </Link>

                            </div>


                            <div
                                style={{
                                    display:
                                        "grid",
                                    gridTemplateColumns:
                                        "repeat(2,minmax(0,1fr))",
                                    gap:
                                        "16px"
                                }}
                            >

                                {[
                                    {
                                        icon: "👁️",
                                        title: "Vision Missions",
                                        desc: "Free eye care and glasses for those in need"
                                    },
                                    {
                                        icon: "🌍",
                                        title: "Humanitarian Aid",
                                        desc: "Disaster relief and emergency support"
                                    },
                                    {
                                        icon: "🎓",
                                        title: "Youth Programs",
                                        desc: "Leo Clubs and youth leadership development"
                                    },
                                    {
                                        icon: "🤝",
                                        title: "Community Service",
                                        desc: "Local initiatives and volunteer opportunities"
                                    },
                                ].map(
                                    (item) => (
                                        <div
                                            key={
                                                item.title
                                            }
                                            style={{
                                                backgroundColor:
                                                    "#f0f7ff",
                                                borderRadius:
                                                    "12px",
                                                padding:
                                                    "20px",
                                                border:
                                                    "1px solid #dceeff"
                                            }}
                                        >

                                            <div
                                                style={{
                                                    fontSize:
                                                        "1.5rem",
                                                    marginBottom:
                                                        "12px"
                                                }}
                                            >
                                                {
                                                    item.icon
                                                }
                                            </div>

                                            <h3
                                                style={{
                                                    color:
                                                        "#0067B1",
                                                    fontWeight:
                                                        "bold",
                                                    fontSize:
                                                        "0.875rem",
                                                    marginBottom:
                                                        "4px"
                                                }}
                                            >
                                                {
                                                    item.title
                                                }
                                            </h3>

                                            <p
                                                style={{
                                                    color:
                                                        "#6b7280",
                                                    fontSize:
                                                        "0.75rem",
                                                    lineHeight:
                                                        1.6
                                                }}
                                            >
                                                {
                                                    item.desc
                                                }
                                            </p>

                                        </div>
                                    )
                                )}

                            </div>

                        </div>

                    </div>

                </section>


                {/* =====================================================
                    QUICK NAVIGATION
                ===================================================== */}

                <section
                    style={{
                        padding:
                            "64px 0",
                        backgroundColor:
                            "#f9fafb"
                    }}
                >

                    <div
                        style={{
                            maxWidth:
                                "1280px",
                            margin:
                                "0 auto",
                            padding:
                                isLG
                                    ? "0 32px"
                                    : "0 16px"
                        }}
                    >

                        <div
                            style={{
                                textAlign:
                                    "center",
                                marginBottom:
                                    "40px"
                            }}
                        >

                            <span
                                style={{
                                    color:
                                        "#0067B1",
                                    fontSize:
                                        "12px",
                                    fontWeight:
                                        "bold",
                                    letterSpacing:
                                        "0.1em",
                                    textTransform:
                                        "uppercase",
                                    borderBottom:
                                        "2px solid #FFD500",
                                    paddingBottom:
                                        "4px"
                                }}
                            >
                                Explore
                            </span>

                            <h2
                                style={{
                                    fontSize:
                                        "1.875rem",
                                    fontWeight:
                                        800,
                                    color:
                                        "#0067B1",
                                    marginTop:
                                        "20px"
                                }}
                            >
                                Quick Navigation
                            </h2>

                        </div>

                        <div
                            style={{
                                display:
                                    "grid",
                                gridTemplateColumns:
                                    isMD
                                        ? "repeat(3,minmax(0,1fr))"
                                        : "minmax(0,1fr)",
                                gap:
                                    "24px"
                            }}
                        >

                            {[
                                {
                                    to: "/international",
                                    title: "International",
                                    desc: "Connect with Lions Clubs International for global programs, resources, and initiatives.",
                                    bg: "#0067B1"
                                },
                                {
                                    to: "/multiple-districts",
                                    title: "Multiple Districts",
                                    desc: "Explore all eight districts of MD 320 and find your local Lions community.",
                                    bg: "#004f8a"
                                },
                                {
                                    to: "/contact",
                                    title: "Contact",
                                    desc: "Reach out to MD 320 headquarters for information, support, or membership inquiries.",
                                    bg: "#003d70"
                                }
                            ].map(
                                (card) => (
                                    <Link
                                        key={
                                            card.to
                                        }
                                        to={
                                            card.to
                                        }
                                        style={{
                                            backgroundColor:
                                                card.bg,
                                            color:
                                                "#ffffff",
                                            borderRadius:
                                                "12px",
                                            padding:
                                                "32px",
                                            textDecoration:
                                                "none",
                                            display:
                                                "block"
                                        }}
                                    >

                                        <h3
                                            style={{
                                                fontWeight:
                                                    800,
                                                fontSize:
                                                    "1.25rem",
                                                marginBottom:
                                                    "12px"
                                            }}
                                        >
                                            {
                                                card.title
                                            }
                                        </h3>

                                        <p
                                            style={{
                                                color:
                                                    "rgba(255,255,255,0.75)",
                                                fontSize:
                                                    "0.875rem",
                                                lineHeight:
                                                    1.6,
                                                marginBottom:
                                                    "16px"
                                            }}
                                        >
                                            {
                                                card.desc
                                            }
                                        </p>

                                        <span
                                            style={{
                                                color:
                                                    "#FFD500",
                                                fontSize:
                                                    "0.75rem",
                                                fontWeight:
                                                    "bold"
                                            }}
                                        >
                                            Learn More →
                                        </span>

                                    </Link>
                                )
                            )}

                        </div>

                    </div>

                </section>


                {/* =====================================================
                    DISTRICT OVERVIEW
                ===================================================== */}

                <section
                    style={{
                        padding:
                            "80px 0",
                        backgroundColor:
                            "#ffffff"
                    }}
                >

                    <div
                        style={{
                            maxWidth:
                                "1280px",
                            margin:
                                "0 auto",
                            padding:
                                isLG
                                    ? "0 32px"
                                    : "0 16px"
                        }}
                    >

                        <div
                            style={{
                                display:
                                    "flex",
                                flexDirection:
                                    isSM
                                        ? "row"
                                        : "column",
                                justifyContent:
                                    "space-between",
                                alignItems:
                                    isSM
                                        ? "flex-end"
                                        : "flex-start",
                                gap:
                                    "16px",
                                marginBottom:
                                    "48px"
                            }}
                        >

                            <div>

                                <span
                                    style={{
                                        color:
                                            "#0067B1",
                                        fontSize:
                                            "12px",
                                        fontWeight:
                                            "bold",
                                        letterSpacing:
                                            "0.1em",
                                        textTransform:
                                            "uppercase",
                                        borderBottom:
                                            "2px solid #FFD500",
                                        paddingBottom:
                                            "4px"
                                    }}
                                >
                                    Our Districts
                                </span>

                                <h2
                                    style={{
                                        fontSize:
                                            "1.875rem",
                                        fontWeight:
                                            800,
                                        color:
                                            "#0067B1",
                                        marginTop:
                                            "20px"
                                    }}
                                >
                                    District Overview
                                </h2>

                            </div>

                            <Link
                                to="/multiple-districts"
                                style={{
                                    color:
                                        "#0067B1",
                                    fontWeight:
                                        600,
                                    fontSize:
                                        "0.875rem",
                                    textDecoration:
                                        "none"
                                }}
                            >
                                View all districts →
                            </Link>

                        </div>


                        <div
                            style={{
                                display:
                                    "grid",
                                gridTemplateColumns:
                                    isLG
                                        ? "repeat(4,minmax(0,1fr))"
                                        : isMD
                                            ? "repeat(2,minmax(0,1fr))"
                                            : "minmax(0,1fr)",
                                gap:
                                    "20px"
                            }}
                        >

                            {districts.map(
                                (d) => (
                                    <Link
                                        key={
                                            d
                                        }
                                        to={`/district/${d.toLowerCase()}`}
                                        style={{
                                            border:
                                                "1px solid #f3f4f6",
                                            borderRadius:
                                                "12px",
                                            padding:
                                                "24px",
                                            textDecoration:
                                                "none",
                                            display:
                                                "flex",
                                            flexDirection:
                                                "column",
                                            justifyContent:
                                                "space-between",
                                            backgroundColor:
                                                "#ffffff"
                                        }}
                                    >

                                        <div>

                                            <div
                                                style={{
                                                    fontSize:
                                                        "1.875rem",
                                                    fontWeight:
                                                        900,
                                                    color:
                                                        "#0067B1",
                                                    marginBottom:
                                                        "16px"
                                                }}
                                            >
                                                {
                                                    d
                                                }
                                            </div>

                                            <div
                                                style={{
                                                    width:
                                                        "100%",
                                                    height:
                                                        "4px",
                                                    backgroundColor:
                                                        "#FFD500",
                                                    borderRadius:
                                                        "9999px",
                                                    marginBottom:
                                                        "16px"
                                                }}
                                            />

                                            <div
                                                style={{
                                                    color:
                                                        "#6b7280",
                                                    fontSize:
                                                        "0.75rem",
                                                    fontWeight:
                                                        500,
                                                    marginBottom:
                                                        "24px"
                                                }}
                                            >
                                                {
                                                    districtDescriptions[
                                                        d
                                                    ]
                                                }
                                            </div>

                                        </div>

                                        <span
                                            style={{
                                                fontSize:
                                                    "0.75rem",
                                                fontWeight:
                                                    "bold",
                                                color:
                                                    "#0067B1"
                                            }}
                                        >
                                            READ MORE →
                                        </span>

                                    </Link>
                                )
                            )}

                        </div>

                    </div>

                </section>


                {/* =====================================================
                    CTA
                ===================================================== */}

                <section
                    style={{
                        padding:
                            "64px 0",
                        backgroundColor:
                            "#FFD500",
                        textAlign:
                            "center"
                    }}
                >

                    <div
                        style={{
                            maxWidth:
                                "1280px",
                            margin:
                                "0 auto",
                            padding:
                                isLG
                                    ? "0 32px"
                                    : "0 16px"
                        }}
                    >

                        <h2
                            style={{
                                fontSize:
                                    "1.875rem",
                                fontWeight:
                                    800,
                                color:
                                    "#0067B1",
                                marginBottom:
                                    "16px"
                            }}
                        >
                            Ready to Make a Difference?
                        </h2>

                        <p
                            style={{
                                color:
                                    "rgba(0,103,177,0.7)",
                                fontSize:
                                    "1rem",
                                marginBottom:
                                    "32px",
                                maxWidth:
                                    "512px",
                                margin:
                                    "0 auto 32px auto"
                            }}
                        >
                            Join one of our 1,200+ clubs across MD 320 and become part of the world's largest service organization.
                        </p>

                        <div
                            style={{
                                display:
                                    "flex",
                                flexWrap:
                                    "wrap",
                                gap:
                                    "16px",
                                justifyContent:
                                    "center"
                            }}
                        >

                            <Link
                                to="/contact"
                                style={{
                                    backgroundColor:
                                        "#0067B1",
                                    color:
                                        "#ffffff",
                                    fontWeight:
                                        "bold",
                                    padding:
                                        "12px 28px",
                                    borderRadius:
                                        "6px",
                                    textDecoration:
                                        "none"
                                }}
                            >
                                Get in Touch
                            </Link>

                            <Link
                                to="/multiple-districts"
                                style={{
                                    backgroundColor:
                                        "#ffffff",
                                    color:
                                        "#0067B1",
                                    fontWeight:
                                        "bold",
                                    padding:
                                        "12px 28px",
                                    borderRadius:
                                        "6px",
                                    textDecoration:
                                        "none"
                                }}
                            >
                                Find Your District
                            </Link>

                        </div>

                    </div>

                </section>

            </div>

            <Footer />
        </>
    );
}
